import axios from "axios";
import authHeader from "@/services/auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v2`;
const main = "Common";
const sub = "BankStatementAI";

class BankStatementAIService {
  run(fileDataId, bankType, embeddedDocIds) {
    return axios
      .post(
        `${API_URL}/${main}/${sub}/Run/${fileDataId}/${bankType}`,
        embeddedDocIds,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new BankStatementAIService();
